<template>
    <div id="agencies-manager" class="mx-2">
        <div class="row mt-3">
            <div class="col-12">
                <h1>Agencies</h1>
                <p>Manage all agencies in the system here.</p>
            </div>
        </div>

        <div class="card mb-3 table-card">
            <div class="card-header">
                <div class="row">
                    <div class="col-md-6 col-12">
                        <h3 class="mt-2">Agencies ({{filtered_agency_list.length}})</h3>
                    </div>
                    <div class="col-md-6 d-none d-md-block">
                        <div class="d-flex justify-content-end justify-self-end gap-2">
                            <div class="position-relative">
                                <input type="text" class="search-box form-control me-1 py-2" placeholder="Search by Agency Name..." aria-label="Search by Agency Name..." v-model="search_key" @input="handleFilterSelection()">
                                <i class="fa fa-search search-placeholder-icon" v-if="search_key === ''"></i>
                            </div>
                            <a class="btn btn-primary float-end" href="/admin/agencies/new">
                                <i class="fa fas fa-fw fa-plus"></i> Add Agency
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body p-0">
                <div class="table-width-responsive">
                    <table class="table table-with-pagination mb-0">
                        <thead>
                            <tr class="table-header-row">
                                <th @click="sortByKey('name')" class="d-table-cell">
                                    <div class="d-flex flex-row">
                                        Agency
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{'sort-key-active': sort_key === 'name' && sort_order === 'asc'}" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{'sort-key-active': sort_key === 'name' && sort_order === 'des'}" alt="">                                                            
                                        </div>
                                    </div>
                                </th>
                                <th class="d-none d-sm-table-cell">Domain</th>
                                <th class="d-none d-md-table-cell">URL Slug</th>
                                <th class="d-table-cell column-sort-disabled pe-3" width="1">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(agency, index) in list_shown" :key="agency.id">
                                <td class="d-table-cell">
                                    <a :href="'/admin/agencies/' + agency.id + '/profile'">
                                        {{ agency.name }}
                                    </a>
                                </td>
                                <td class="d-none d-sm-table-cell">{{ agency.domain }}</td>
                                <td class="d-none d-md-table-cell">{{ agency.url_slug }}</td>
                                <td class="d-table-cell">
                                    <div class="dropdown d-flex justify-content-center">
                                        <button class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" aria-label="Button">
                                            <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                            <a class="dropdown-item" :href="'/admin/agencies/' + agency.id + '/profile'">
                                                <img class="icon" src="/img/icons/avid-icons/edit.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit Agency" alt="">
                                                Edit Agency
                                            </a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item text-danger" href="#" @click.prevent="deleteAgency(agency)">
                                                <img class="icon red-icon" src="/img/icons/avid-icons/trash.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete Agency" alt="">
                                                Delete Agency
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select class="form-select" name="num_per_page" id="num_per_page" v-model="num_per_page" @change="reloadPagination(filtered_agency_list)" aria-label="Num Per Page">
                                                    <option value="5000" >ALL</option>
                                                    <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                            <div class="position-relative">
                                                <select class="form-select" name="num_per_page" id="num_per_page" v-model="num_per_page" @change="reloadPagination(filtered_agency_list)" aria-label="Num Per Page">
                                                    <option value="5000" >ALL</option>
                                                    <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ filtered_agency_list.length === 0 ? '0' : item_interval }} of {{ filtered_agency_list.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click="moveToPrevPage(filtered_agency_list)" :disabled="page_index === 0" data-bs-toggle="tooltip" title="Previous page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                            </button>   

                                            <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                                <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="{'current-page': page === page_index + 1}" @click="moveToPage(page, filtered_agency_list)">
                                                    {{page}}
                                                </button>  
                                            </div>
                                            <div class="d-flex page-selector" v-else>
                                                <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="{'current-page': page === page_index + 1}" @click="moveToPage(page, filtered_agency_list)">
                                                    {{page}}
                                                </button>  

                                                <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                ...
                                                </button>  
                                                <button v-if="page_index >= 2 && page_index < page_index_array.length - 1" class="btn btn-none btn-icon-only-md current-page">
                                                    {{page_index + 1}} 
                                                </button>  

                                                <button v-if="page_index < page_index_array.length - 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                ...
                                                </button>  
                                                <button :class="{'current-page': page_index === page_index_array.length - 1}" class="btn btn-none btn-icon-only-md" @click="moveToPage(page_index_array.length, filtered_agency_list)" :key="page_index_array.length">
                                                    {{ page_index_array.length }}
                                                </button>  
                                            </div>

                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click="moveToNextPage(filtered_agency_list)" :disabled="page_index === page_count - 1" data-bs-toggle="tooltip" title="Next page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                            </button>   
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tablePaginationMixin from '../../mixins/table_pagination';
    import Swal from 'sweetalert2';
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'AgenciesManager',
        mixins: [tablePaginationMixin],
        props: {
            agencies: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                filtered_agency_list: [],
                list_shown:[],
                search_key: '',
                sort_key: null,
                sort_order: 'asc',
            };
        },
        beforeMount() {
            this.filtered_agency_list = this.agencies;
            this.reloadPagination(this.filtered_agency_list);
        },
        mounted() {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

            for (var i = 0; i < tooltipTriggerList.length; i++) {
              (function(index) {
                tooltipTriggerList[index].addEventListener('click', function() {
                  tooltipList[index].hide();
                });
                tooltipTriggerList[index].addEventListener('mouseleave', function() {
                  tooltipList[index].hide();
                });
              })(i);
            }
        },
        methods: {
            handleFilterSelection(){
                var filtered_list = [];

                this.filtered_agency_list.forEach(agency => {
                    let in_search = this.search_key == '' || agency.name.toLowerCase().includes(this.search_key.toLowerCase());

                    if (in_search){
                        filtered_list.push(agency);
                    }
                });
            
                this.filtered_agency_list = filtered_list;
                this.reloadPagination(this.filtered_agency_list);
                this.$forceUpdate();
            },
            sortByKey(key){
                this.sort_key = key;
                if (this.sort_key != key){
                    this.sort_order = 'asc';
                } else{
                    this.sort_order = (this.sort_order == 'asc'? 'des':'asc');
                }
                this.sortDataWithLabel();
            },
            sortDataWithLabel(){
                if(this.sort_order == 'asc')
                    this.filtered_agency_list.sort((a, b) => (a[this.sort_key ] > b[this.sort_key ]) ? 1 : -1);
                else
                    this.filtered_agency_list.sort((a, b) => (a[this.sort_key ] < b[this.sort_key ]) ? 1 : -1);                    
                
                this.reloadPagination(this.filtered_agency_list);
            },
            deleteAgency(agency) {
                var self = this;

                Swal.fire({
                    title: "Are you sure you want to delete this agency?",
                    text: "This action cannot be undone.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete",
                    customClass: {
                        popup: 'swal-warning'
                    },
                    html: `
                        <div class="form-check mt-3">
                            <input class="form-check-input" type="checkbox" id="deleteUsers" aria-label="Checkbox">
                            <label class="form-check-label" for="deleteUsers">
                                Also delete all users associated with this agency
                            </label>
                        </div>
                    `,
                    preConfirm: () => {
                        return {
                            deleteUsers: document.getElementById('deleteUsers').checked
                        }
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.axios.post('/api/agencies/' + agency.id + '/delete', {
                            delete_users: result.value.deleteUsers
                        })
                            .then(response => {
                                if (response.status == 200) {
                                    var index = this.filtered_agency_list.findIndex(a => a.id == agency.id);
                                    this.filtered_agency_list.splice(index, 1);
                                    this.reloadPagination(this.filtered_agency_list);

                                    Swal.fire({
                                        title: "Deleted!",
                                        text: "This agency has been removed.",
                                        icon: "success",
                                        customClass: {
                                            popup: 'swal-success'
                                        },
                                    });
                                }
                            })
                            .catch(error => {
                                let errorMessage = 'An error occurred while deleting the agency.';
                                
                                if (error.response) {
                                    switch (error.response.status) {
                                        case 403:
                                            errorMessage = 'You are not authorized to delete this agency.';
                                            break;
                                        case 404:
                                            errorMessage = 'Agency not found.';
                                            break;
                                        case 500:
                                            errorMessage = 'Server error occurred while deleting the agency.';
                                            break;
                                    }
                                }

                                Swal.fire({
                                    title: "Error!",
                                    text: errorMessage,
                                    icon: "error",
                                    customClass: {
                                        popup: 'swal-error'
                                    },
                                });
                            });
                    }
                });
            }
        }
    })
</script> 